__turbopack_context__.v({
  "content": "Content-module__T_UVxW__content",
});
